import { Box, List, ListItemButton, Typography, Chip, Stack } from '@mui/material';

const statusColor = {
  planned: 'default',
  'in-development': 'warning',
  sqa: 'info',
  training: 'secondary',
  released: 'success',
  'on-hold': 'error',
};

export default function FeatureList({ features, selectedFeature, onSelect, emptyMessage }) {
  if (features.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary', fontSize: 13 }}>
        {emptyMessage || (<>아직 Feature가 없습니다.<br /><br /><b>+ 새 Feature</b> 로 추가하세요.</>)}
      </Box>
    );
  }
  return (
    <List sx={{ p: 1 }}>
      {features.map((f, i) => (
        <ListItemButton
          key={f.id + '_' + i}
          selected={selectedFeature === f}
          onClick={() => onSelect(f)}
          sx={{ flexDirection: 'column', alignItems: 'flex-start', mb: 0.5, borderRadius: 1 }}
        >
          <Typography variant="caption" sx={{ fontFamily: 'JetBrains Mono, monospace', color: 'text.secondary' }}>
            {f.id}
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {f.name || f.id}
          </Typography>
          <Stack direction="row" spacing={0.5} sx={{ mt: 0.5, alignItems: 'center', flexWrap: 'wrap', gap: 0.5 }}>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {f.owner || 'TBD'}
            </Typography>
            <Chip label={f.status || 'planned'} color={statusColor[f.status] || 'default'} size="small" sx={{ height: 18, fontSize: 10 }} />
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              · {(f.components?.length || 0)}개 SW
            </Typography>
          </Stack>
        </ListItemButton>
      ))}
    </List>
  );
}
